/* Show company inputs on radio check */
document.addEventListener('click', function(event) {
  const radios = document.querySelectorAll('.company-choice input');
  const companyInfo = document.querySelector('.buying-as-company .company-info');
  const alertBox = document.querySelector('.buying-as-company .alert');
  const quickCheckout = document.querySelector('.additional-checkout-buttons');

  const anySelected = Array.from(radios).some(r => r.checked);
  if (!anySelected && quickCheckout) {
    quickCheckout.style.display = 'none';
  }
  for (let i = 0; i < radios.length; i++) {
    radios[i].onchange = function () {
      if (this.id === 'company' && this.checked) {
        companyInfo.style.display = 'block';
      } else if (this.id === 'individual' && this.checked) {
        companyInfo.style.display = 'none';
      }
      if (alertBox) alertBox.style.display = 'none';
      if (quickCheckout) quickCheckout.style.display = 'block';
    };
  }
  if (event.target.matches('button[name="checkout"], .cart__checkout-button')) {
    if (!anySelected) {
      event.preventDefault();
      if (alertBox) alertBox.style.display = 'block';
      if (quickCheckout) quickCheckout.style.display = 'none'; // hide again
    }
  }
});

document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.action.includes('/cart')) {
    const radios = document.querySelectorAll('.company-choice input');
    const alertBox = document.querySelector('.buying-as-company .alert');
    const quickCheckout = document.querySelector('.additional-checkout-buttons');
    const anySelected = Array.from(radios).some(r => r.checked);
    if (!anySelected) {
      event.preventDefault();
      if (alertBox) alertBox.style.display = 'block';
      if (quickCheckout) quickCheckout.style.display = 'none';
    }
  }
});

/* Disable checkout button if company inputs aren't filled */
function validateCompanyCondition() {

  const companyRadio = document.getElementById('company');
  const checkoutBtn = document.querySelector('button[name="checkout"]');
  const requiredInputs = document.querySelectorAll('.company-info input.required');
  const quickCheckout = document.querySelector('.additional-checkout-buttons');
  
  if (companyRadio.checked) {
    const allFilled = Array.from(requiredInputs).every(input => input.value.trim() !== '');
    if (!allFilled) {
      checkoutBtn.classList.add('disabled');
      if (quickCheckout) quickCheckout.classList.add('hidden');
    } else {
      checkoutBtn.classList.remove('disabled');
      if (quickCheckout) quickCheckout.classList.remove('hidden');
    }
  } else {
    checkoutBtn.classList.remove('disabled');
    if (quickCheckout) quickCheckout.classList.remove('hidden');
  }
}

document.addEventListener('input', function(e) {
  if (e.target.matches('input[type="text"]') || e.target.matches('input[type="radio"]')) {
    validateCompanyCondition();
  }
});

window.addEventListener('load', validateCompanyCondition);
document.addEventListener('shopify:cart:updated', validateCompanyCondition);
document.addEventListener('shopify:section:load', validateCompanyCondition);

/* Minimum purchase amount */
function enforceMinimumQuantities() {
  const qtyInputs = document.querySelectorAll('input[name="quantity"], input[name="updates[]"]');

  qtyInputs.forEach(function (input) {
    const minQty = parseInt(input.dataset.min) || 1;
    input.setAttribute("min", minQty);

    const rawTranslated = window.themeTranslations?.minQtyTooltip || "Minimum quantity: 9999";
    const tooltipText = rawTranslated.replace("9999", minQty);

    if (!input.value || parseInt(input.value) < minQty) {
      input.value = minQty;
    }

    input.addEventListener("input", function () {
      if (parseInt(input.value) < minQty) {
        input.value = minQty;
      }
    });

    if (minQty > 1 && !input._tooltipAttached) {
      const tooltip = document.createElement("div");
      tooltip.className = "min-tooltip";
      tooltip.textContent = tooltipText;
      document.body.appendChild(tooltip);
  
      const wrapper = input.closest('.quantity, .quantity-selector, .product-form__input, .cart-item__quantity') || input;
  
      wrapper.addEventListener("mouseenter", function () {
        const rect = input.getBoundingClientRect();
        tooltip.style.left = `${rect.left + window.scrollX}px`;
        tooltip.style.top = `${rect.top + window.scrollY - 30}px`;
        tooltip.style.display = "block";
      });
  
      wrapper.addEventListener("mouseleave", function () {
        tooltip.style.display = "none";
      });
  
      input._tooltipAttached = true;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  enforceMinimumQuantities();

  const observer = new MutationObserver(function () {
    enforceMinimumQuantities();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});